import { useQuery } from '@tanstack/react-query';
import { getFunnelInboxMessages } from 'API/linkedin-funnel';
import { AxiosError } from 'axios';
import { useUserData } from 'hooks/use-user-data';
import { useEffect } from 'react';
import useErrorStore, { CustomErrorClass } from 'stores/error-store';
import { Message } from '../campaign-statistics/campaign-statistics-types';

const FETCH_INTERVAL = 15 * 60 * 1000;

export const useInboxMessages = (campaignId: string | false, profileId: string | false) => {
  const { token } = useUserData();

  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const { data, isLoading, isError, error } = useQuery<Message[]>({
    queryKey: ['inboxMessages', token, campaignId, profileId],
    queryFn: ({ signal }) => getFunnelInboxMessages(campaignId as string, profileId as string, signal),
    enabled: !!campaignId && !!profileId,
    refetchInterval: FETCH_INTERVAL,
  });

  useEffect(() => {
    if (isError) {
      const customError = new CustomErrorClass(error as AxiosError);
      handleOpenErrorDialog(customError, customError.request, customError.requestType);
    }
  }, [isError, error]);

  return {
    messages: data || [],
    isLoading,
  };
};
